const AdminHeader = (props) => {
  return (
    <div className='header_container'>
    </div>
  );
}
export default AdminHeader;